import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { NewWarRequest, NewWarResponse } from '@warplan/shared';
import { api } from './api-client.js';
import { MAP_OBJECTS_QUERY_KEY } from './map-objects-api.js';
import { MAP_SETTINGS_QUERY_KEY } from './map-settings-api.js';

/**
 * Admin "New war" reset: wipes every map object and replaces the
 * disabled-hex list with the provided keys (usually every ATLAS key
 * so the planner starts blank). The realtime channel will also push
 * `objects.cleared` + `mapsettings.updated` events, but we eagerly
 * sync the local cache so the UI updates without a round-trip.
 */
export function useNewWar() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: NewWarRequest) =>
      api.post<NewWarResponse>('/api/admin/new-war', input),
    onSuccess: (res) => {
      qc.setQueryData(MAP_OBJECTS_QUERY_KEY, { objects: [] });
      qc.setQueryData(MAP_SETTINGS_QUERY_KEY, res.settings);
    },
  });
}
